/**
 * @generated SignedSource<<03609fef359f35d3ce3298522edc3dcd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type useLoginInitSubscription$variables = {};
export type useLoginInitSubscription$data = {
  readonly userStatUpdated: {
    readonly uuid: string;
    readonly name: string;
    readonly value: number;
    readonly meta: any | null;
  };
};
export type useLoginInitSubscription = {
  variables: useLoginInitSubscription$variables;
  response: useLoginInitSubscription$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UserStatUser",
    "kind": "LinkedField",
    "name": "userStatUpdated",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uuid",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "meta",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useLoginInitSubscription",
    "selections": (v0/*: any*/),
    "type": "RootSubscriptionType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useLoginInitSubscription",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "17d21b37d08631004d914be4b8f6f58b",
    "id": null,
    "metadata": {},
    "name": "useLoginInitSubscription",
    "operationKind": "subscription",
    "text": "subscription useLoginInitSubscription {\n  userStatUpdated {\n    uuid\n    name\n    value\n    meta\n  }\n}\n"
  }
};
})();

(node as any).hash = "a212af9b19af7eca5e550eb117e994e0";

export default node;
